import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { CartService } from '../../../../my-cart/shared/cart.service';

import { CartItem } from '../../../../models/cart-item.model';

@Component({
  selector: 'app-toolbar-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class ToolbarCartComponent implements OnInit, OnDestroy {
  public items: CartItem[];
  public total: number;
  private cartSubscription: Subscription;
  public showDropdown: boolean = false; // Added to control dropdown visibility
  private hideTimeout: any; // For delayed hiding
  itemsCount: number = 0; // To track the number of items in the cart

  constructor(private cartService: CartService) {}

  ngOnInit() {
    this.items = this.cartService.getItems();
    this.total = this.cartService.getTotal();
    this.cartSubscription = this.cartService.itemsChanged.subscribe(
      (items: CartItem[]) => {
        this.items = items;
        this.itemsCount = items.reduce((count, item) => count + item.quantity, 0); // Calculate total items in cart
        this.total = this.cartService.getTotal();
      }
    );
  }

  public onRemoveItem(event: Event, item: CartItem) {
    event.stopPropagation();
    this.cartService.removeItem(item);
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
  }
  onMouseEnterCart() {
    clearTimeout(this.hideTimeout); // Cancel any pending hide action
    this.showDropdown = true;
  }

  onMouseLeaveCart() {
    // Delay hiding to allow moving to the dropdown
    this.hideTimeout = setTimeout(() => {
      this.showDropdown = false;
    }, 100);
  }

  onMouseEnterDropdown() {
    clearTimeout(this.hideTimeout); // Keep dropdown open while hovering over it
    this.showDropdown = true;
  }

  onMouseLeaveDropdown() {
    // Hide dropdown after a short delay when leaving the dropdown
    this.hideTimeout = setTimeout(() => {
      this.showDropdown = false;
    }, 100);
  }
}
